export const mixinFormRecaptcha = {
  props: {
    recaptcha: {
      type: Object,
      required: false,
      validator: function (value) {
        return (
          value?.recaptchaSiteKey &&
          value?.recaptchaActionName &&
          value?.recaptchaValidationAPI &&
          value?.recaptchaErrorMsg
        );
      },
    },
  },
  data() {
    return { recaptchaError: null };
  },
  methods: {
    async peformRecaptcha() {
      return new Promise((resolve, reject) => {
        // No recaptcha config, ignore this flow
        if (!this.recaptcha) {
          resolve(true);
          return;
        }

        this.getRecaptchaToken()
          .then((token) => {
            return this.validateRecaptchaToken(token)
              .then((canSubmit) => {
                this.recaptchaError = canSubmit
                  ? null
                  : this.recaptcha.recaptchaErrorMsg;
                resolve(canSubmit);
              })
              .catch(() => {
                reject();
              });
          })
          .catch(() => reject());
      });
    },
    async getRecaptchaToken() {
      return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
          console.error('Recaptcha is not correctly loaded.');
          reject();
        }

        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute(
            this.recaptcha.recaptchaSiteKey,
            {
              action: this.recaptcha.recaptchaActionName,
            }
          );
          resolve(token);
        });
      });
    },
    async validateRecaptchaToken(token) {
      return fetch(this.recaptcha.recaptchaValidationAPI, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: token }),
      })
        .then((response) => {
          if (response.status === 200) return Promise.resolve(true);
          if (response.status === 400) return Promise.resolve(false);
          return Promise.reject();
        })
        .catch(() => {
          return Promise.reject();
        });
    },
  },
};
